import { of } from "rxjs";
import { filter, mergeMap } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { BaseEpicsBuilder } from "../epicsBuilder.js";
import "../actions.js";
import { fileActions } from "./actions.js";
class FileEpicsBuilder extends BaseEpicsBuilder {
  _service;
  constructor(service) {
    super();
    this._service = service;
  }
  buildEpicList() {
    return [this.buildDownloadEpic()];
  }
  buildDownloadEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(fileActions.download)),
      mergeMap((action) => {
        this._service.download(action.payload);
        return of();
      })
    );
  }
}
export {
  FileEpicsBuilder
};
//# sourceMappingURL=epics.js.map
